import type { ReactNode } from 'react'

import type { PaymentContentOrderType } from 'sections/subscription/Content/SubscriptionContent'
import { FeaturedIn } from 'sections/subscription/FeaturedIn'
import { MoneyBackGuarantee } from 'sections/subscription/MoneyBackGuarantee'
import { PaywallFaq } from 'sections/subscription/PaywallFaq'
import { PlanHighlights } from 'sections/subscription/PlanHighlights'
import { Reviews } from 'sections/subscription/Reviews'
import { UserResults } from 'sections/subscription/UserResults'

type Props = {
  bottomPlan: ReactNode
  checkout: ReactNode
  paymentContentOrderType: PaymentContentOrderType
  topPlan: ReactNode
}

export const SubscriptionSections = ({
  bottomPlan,
  checkout,
  paymentContentOrderType,
  topPlan,
}: Props) => {
  switch (paymentContentOrderType) {
    case 'proof_before_checkout':
      return (
        <>
          {topPlan}
          <PlanHighlights />
          <FeaturedIn />
          <UserResults />
          <Reviews />
          <PaywallFaq />
          {bottomPlan}
          {checkout}
          <MoneyBackGuarantee />
        </>
      )
    case 'benefits_first':
      return (
        <>
          <PlanHighlights />
          {topPlan}
          {checkout}
          <FeaturedIn />
          <UserResults />
          <Reviews />
          <PaywallFaq />
          {bottomPlan}
          <MoneyBackGuarantee />
        </>
      )
    default:
      return (
        <>
          {topPlan}
          {checkout}
          <PlanHighlights />
          <FeaturedIn />
          <UserResults />
          <Reviews />
          <PaywallFaq />
          {bottomPlan}
          <MoneyBackGuarantee />
        </>
      )
  }
}
